const libraries
    = [
        {
            id: 1,
            name: 'Bootstrap',
            src: ('../img/logos//bootstrap.png')
        }
        ,
        {
            id: 2,
            name: 'Material-UI',
            src: ('../img/logos//materialui.png')
        },
        {
            id: 3,
            name: 'MDB',
            src: ('../img/logos//mdb.png')
        },
        {
            id: 4,
            name: 'jQuery',
            src: ('../img/logos//jquery.png')
        },
        {
            id: 5,
            name: 'Google API',
            src: ('../img/logos/google.png')
        },
        {
            id: 6,
            name: 'W3',
            src: ('../img/logos//w3.png')
        },

    ];
export default libraries


